import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

const linkFactoryDefaultProp = ({children, ...rest} = {}) => <a {...rest}>{children}</a>

export const GeneralLinks = ({linkFactory: LinkComponent = linkFactoryDefaultProp}) => {
  const {domain, i18n} = useContext(Context)
  const {LINKS} = domain.get('config').get('footer')

  return (
    <div className="mt-SharedCorporateFooter-generalLinksContainer">
      {LINKS.map(column => {
        return (
          <div key={column.title} className="mt-SharedCorporateFooter-linksColumn">
            <h3 className="mt-SharedCorporateFooter-linksColumnTitle">{i18n.t(column.title)}</h3>

            <ul className="mt-SharedCorporateFooter-linksList">
              {column.urls.map(singleLinkInfo => {
                const key = singleLinkInfo.text.replace(' ', '')
                const linkText = i18n.t(singleLinkInfo.text)

                return (
                  <li key={key} className="mt-SharedCorporateFooter-linksListItem">
                    <LinkComponent href={singleLinkInfo.url}>{linkText}</LinkComponent>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}

GeneralLinks.propTypes = {
  linkFactory: PropTypes.any
}
